import React from 'react';
import { RouteObject } from 'react-router-dom';
import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { UserRoutes } from './RouteHelpers';
import UserDetailPage from './containers/UserDetailPage';
import { teamPermissions } from '../team/permissions/Team';

const UsersListPage = React.lazy(() => import('./containers/UsersListPage'));

// This page will be hidden for the time being
export const userRoutes: RouteObject = {
  path: UserRoutes.PageIndex,
  element: (
    <PermissionsProtectedRoute
      pageId={teamPermissions.pageId}
      currentPath={UserRoutes.PageIndex}
    />
  ),
  children: [
    // The static `list` segment outranks `users/:id` in React Router, the same
    // way `/teams/reconciliation-mismatches` coexists with `/teams/:id`.
    {
      path: UserRoutes.UsersList,
      element: (
        <React.Suspense fallback={undefined}>
          <UsersListPage />
        </React.Suspense>
      ),
    },
    {
      path: UserRoutes.UserDetail,
      element: <UserDetailPage />,
    },
  ],
};
